import * as React from 'react';

import { CitationModule } from '@coursera-web/cds-labs';

import type { ConsumerSpecializationPageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerSpecializationPageQuery';
import { getCareerOutcomesConsumerDisclaimers } from 'bundles/unified-description-page-common/utils/careerOutcomes';

type Props = {
  pageData: ConsumerSpecializationPageFieldsFragment;
};

const ConsumerProfessionalCertificateCitationModuleRenderer = ({ pageData }: Props) => {
  return (
    <CitationModule
      removeTopPadding
      citations={pageData.careerOutcomes?.disclaimers || getCareerOutcomesConsumerDisclaimers()}
    />
  );
};

export default ConsumerProfessionalCertificateCitationModuleRenderer;
